import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BRAND } from "@/lib/brand";

// Module-level cache so multiple pickers on the same page don't refetch.
let _cachedProjects = null;
let _inflight = null;

export function clearProjectCache() {
  _cachedProjects = null;
  _inflight = null;
}

export async function fetchActiveProjects() {
  if (_cachedProjects) return _cachedProjects;
  if (_inflight) return _inflight;
  _inflight = api
    .get("/projects")
    .then(({ data }) => {
      _cachedProjects = data.projects || [];
      return _cachedProjects;
    })
    .catch(() => {
      _cachedProjects = [];
      return [];
    })
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export default function ProjectPicker({
  value,
  onChange,
  disabled,
  includeNone = true,
  testId,
}) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchActiveProjects().then((list) => {
      if (!cancelled) {
        setProjects(list);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChange = (e) => {
    const next = e.target.value || null;
    onChange?.(next);
  };

  return (
    <select
      value={value || ""}
      onChange={handleChange}
      disabled={disabled || loading}
      data-testid={testId || "project-picker"}
      className="w-full px-3 py-2 rounded-lg border border-slate-300 bg-white text-slate-900 focus:outline-none focus:ring-2 disabled:opacity-70"
      style={{ "--tw-ring-color": BRAND.teal }}
    >
      {includeNone && <option value="">— No project —</option>}
      {projects.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
          {p.client ? ` · ${p.client}` : ""}
        </option>
      ))}
    </select>
  );
}
